module.exports = __webpack_public_path__ + "static/media/tumb4.12ca6536.png";